import React, {h, Component} from 'preact';
import {PropTypes} from 'preact-compat';
import {debounce} from 'lodash';

export default class AutoCompleteInput extends Component {
    static get propTypes() {
        return {
            onTextChange: PropTypes.func,
            inputProps: PropTypes.object,
            onSelect: PropTypes.func
        };
    }

    state = {
        textInputValue: '',
        autoCompleteEntries: [],
        selecting: false
    };

    debouncedOnTextChange;

    componentDidMount() {
        const {onTextChange, initialEntries} = this.props;
        if (initialEntries && !!initialEntries.length) {
            this.setState({autoCompleteEntries: initialEntries});
        }
        if (onTextChange) {
            this.debouncedOnTextChange = debounce(
                textInputValue =>
                    onTextChange(textInputValue, autoCompleteEntries =>
                        this.setState({autoCompleteEntries, selecting: true})
                    ),
                300,
                {leading: true, trailing: true}
            );
        }
    }

    handleInput = ({target: {value: textInputValue}}) => {
        const {minLength = 3} = this.props;

        this.setState({textInputValue});

        if (textInputValue.length < minLength) {
            this.setState({selecting: false});
            return;
        }

        if (this.debouncedOnTextChange) {
            this.debouncedOnTextChange(textInputValue);
        }
    };

    handleSelection = textInputValue => {
        if (this.props.asSelect) {
            this.setState({textInputValue: '', selecting: false});
        } else {
            this.setState({textInputValue, selecting: false});
        }
        if (this.props.onSelect) {
            this.props.onSelect(textInputValue);
        }
    };

    render() {
        const {autoCompleteEntries, textInputValue, selecting} = this.state;
        const {asSelect, initialEntries, inputProps} = this.props;
        const textInputValueRegex = textInputValue.replace(new RegExp('W', 'gi'), match => `\\${match}`);

        return (
            <div className="autocomplete-container">
                <input
                    type="text"
                    onInput={this.handleInput}
                    value={textInputValue}
                    onBlur={() =>
                        setTimeout(() => {
                            this.setState({selecting: false});
                        }, 200)
                    }
                    onKeyDown={event => {
                        if (event.key === 'Enter') {
                            event.preventDefault();
                            event.stopPropagation();
                            this.handleSelection(textInputValue);
                        }
                    }}
                    {...inputProps}
                    onFocus={() => {
                        if (asSelect) {
                            this.setState({selecting: true});
                        }
                    }}
                />
                {!!autoCompleteEntries.length && selecting && (
                    <div className="autocomplete-open">
                        {autoCompleteEntries.map(entry => (
                            <div
                                key={entry}
                                className="autocomplete-suggestion"
                                onClick={() => this.handleSelection(entry)}
                                dangerouslySetInnerHTML={{
                                    __html: entry.replace(
                                        new RegExp(textInputValueRegex, 'gi'),
                                        match => `<b>${match}</b>`
                                    )
                                }}
                            />
                        ))}
                    </div>
                )}
            </div>
        );
    }
}
